module.exports = __webpack_public_path__ + "img/user.bf54db81.svg";